/**
 * Expectations, each object has an id!
 */
$.nette.ext('ajax-loading-notification', {
    before(jqXHR, settings) {
        this.xhrCounter += 1;
        const counter = this.xhrCounter;
        const configuration = this.obtainConfiguration(settings);
        const ui = (settings.hasOwnProperty('nette') && settings.nette.hasOwnProperty('ui')) ? settings.nette.ui : null;

        if (settings.hasOwnProperty('disableSpinner') && settings.disableSpinner === true) {
            return;
        }

        this.freeze(configuration, counter, ui);
        const self = this;
        // Manually add listener to provider the maintain association between the request and the result in order to unfreeze only the right ones.
        jqXHR.always(() => {
            self.defreeze(configuration, counter, ui);
        });
    },
}, {
    xhrCounter: 0,
    freezedByRequest: {},
    freezed: {},
    obtainConfiguration(settings) {
        if (settings.hasOwnProperty('data-ajax-freeze')) {
            return settings['data-ajax-freeze'];
        } if (settings.hasOwnProperty('nette') && settings.nette.hasOwnProperty('ui')) {
            const ui = settings.nette.ui;
            const direct = ui.getAttribute('data-ajax-freeze');
            if (direct) {
                return JSON.parse(direct);
            }
            if (ui.hasAttribute('data-ajax-freeze-element')) {
                const element = document.getElementById(ui.getAttribute('data-ajax-freeze-element'));
                if (element.hasAttribute('data-ajax-freeze')) {
                    return JSON.parse(element.getAttribute('data-ajax-freeze'));
                }
            }
            return [];
        }
        return null;
    },
    elementToString(element) {
        return element.id;
    },
    freeze(configuration, xhrCounter, ui) {
        if (!configuration) {
            return;
        }
        const toSave = [];
        for (let i = 0; i < configuration.length; i++) {
            const current = configuration[i];
            let element;
            if (current === 'form' && ui) {
                element = $(ui).closest('form');
            } else if (current === 'snippet' && ui) {
                element = $(ui).closest('[id^=snippet-]');
            } else if (current.indexOf('#') === 0) {
                element = $(current);
            }
            if (element.length > 0) {
                element.css('opacity', '0.75');
                if (navigator.appVersion.indexOf('MSIE 10') !== -1) {
                    // This solution is suboptimal as it expects to be wrapped in relative container and also don't cover whole area (i.e. after scrolling)
                    element.prepend(`<div class="loading-notification" style="position: absolute; height: ${element.parent().prop('scrollHeight')}px; background: transparent; width: 100%; z-index: 10000; overflow: auto;"></div>`);
                } else {
                    element.css('pointer-events', 'none');
                    element.css('user-select', 'none');
                }
                toSave.push(this.elementToString(element[0]));
            }
        }
        // Store all by request to restore on finishing this request, also update counts to prevent clash from multiple ajax requests
        this.freezedByRequest[xhrCounter] = toSave;
        const temp = this.freezedByRequest[xhrCounter];
        for (i = 0; i < temp.length; i++) {
            const elementId = temp[i];
            if (!this.freezed.hasOwnProperty(elementId)) {
                this.freezed[elementId] = 0;
            }
            this.freezed[elementId] += 1;
        }
    },
    defreeze(configuration, xhrCounter) {
        if (!configuration) {
            return;
        }
        if (this.freezedByRequest.hasOwnProperty(xhrCounter)) {
            const temp = this.freezedByRequest[xhrCounter];
            for (let i = 0; i < temp.length; i++) {
                const elementId = temp[i];
                if (this.freezed.hasOwnProperty(elementId)) {
                    this.freezed[elementId] -= 1;
                }
                if (this.freezed[elementId] === 0) {
                    delete this.freezed[elementId];
                    const element = $(`#${elementId}`);
                    element.css('opacity', '1');
                    if (navigator.appVersion.indexOf('MSIE 10') !== -1) {
                        element.find('div.loading-notification').remove();
                    } else {
                        element.css('pointer-events', 'auto');
                        element.css('user-select', 'auto');
                    }
                }
            }
        }
        delete this.freezedByRequest[xhrCounter];
    },
});
